<template>
  <event-flow
    detailTitle="事件详情"
    :total="total"
    :listQuery="listQuery"
    :getList="getList"
  >
    <div slot="content" class="contentWrap">
      <!-- tab -->
      <el-tabs
        id="response_tabs"
        class="tabs"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane name="0" :label="'待追责 ' + count[0]"></el-tab-pane>
        <el-tab-pane name="1" :label="'已追责 ' + count[1]"></el-tab-pane>
      </el-tabs>
      <!-- 上传 -->
      <!-- <el-button class="upload" size="small" type="primary" icon="el-icon-myupload">
        <svg-icon class="icon" icon-name="myupload" icon-color="white"></svg-icon>上传
      </el-button>-->
      <!-- 搜索 -->
      <el-input class="input" v-model="input" placeholder="追责对象">
        <!-- <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick"></i> -->
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleIconClick"
        ></el-button>
      </el-input>
      <el-date-picker
        v-model="time"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="timechange"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-table
        header-row-class-name="customTable"
        row-class-name="customTableBody"
        class="table"
        max-height="634"
        height="634"
        @row-click="handleCurrentChange"
        :data="tableData"
        style="width: 100%"
        highlight-current-row
      >
        <el-table-column
          width="180"
          align="center"
          prop="eventcode"
          show-overflow-tooltip
          label="事件编号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="releasetime"
          show-overflow-tooltip
          label="时间"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="object"
          show-overflow-tooltip
          label="追责对象"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="reason"
          show-overflow-tooltip
          label="追责原由"
        ></el-table-column>
        <el-table-column align="center" label="状态" width="100">
          <template slot-scope="scope">
            <div class="status">
              {{ scope.row.status == 0 ? "未追责" : "已追责" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="60">
          <template slot-scope="scope">
            <el-button
              @click="toUploadQuery(scope.row)"
              v-if="scope.row.status == 0"
              type="text"
              size="small"
              >追责</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      style="
        text-align: center;
        padding-top: 50px;
        font-size: 14px;
        color: #99a9ba;
      "
      slot="detail"
      v-if="detail.gid == undefined"
    >
      请先点击选择追责记录！
    </div>
    <div class="detail" slot="detail" v-else>
      <div class="detailItem">
        <div class="detailName">追责对象：</div>
        <div class="detailContent">{{ detail.object }}</div>
      </div>
      <div class="detailItem">
        <div class="detailName">追责原由：</div>
        <div class="detailContent">{{ detail.reason }}</div>
      </div>
      <div class="detailDetail">
        <div
          class="detailDetailWrap"
          v-for="(item, index) in questionList"
          :key="index"
        >
          <div class="detailDate">{{ item }}</div>
        </div>
      </div>
      <div class="detailItem">
        <div class="detailName">发布时间：</div>
        <div class="detailContent">{{ detail.releasetime }}</div>
      </div>
      <abstracts
        title="追责"
        v-if="detail.status == 1"
        :content="detail.content"
        :imglist="imglist"
      />
      <upload-popup
        title="追责"
        :visible="uploadVisible"
        @getimglist="getimglist"
        @dialog-cancel="uploadVisible = false"
      ></upload-popup>
    </div>
    <div
      class="responsibilityBtn"
      slot="bottom"
      v-if="detail.gid != undefined && detail.status == 0"
    >
      <div @click="uploadVisible = true">追责</div>
    </div>
  </event-flow>
</template>

<script>
import { mapState } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
import EventFlow from "@/layout/Event/EventLayout";
import Abstracts from "@/components/Events/Abstracts";
import UploadPopup from "@/components/common/popups/UploadPopup.vue";
// import Pagination from "@/components/common/Pagination";

export default {
  components: {
    EventFlow,
    Abstracts,
    UploadPopup,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.getList();
    this.getCount();
  },
  data() {
    return {
      activeName: "0",
      input: "",
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },
      uploadVisible: false,
      questionList: [],
      tableData: [],
      detail: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      time: [],
      count: [0, 0],
    };
  },
  methods: {
    handleClick() {
      this.detail = [];
      this.tableData = [];
      this.getList();
    },
    timechange() {
      this.getList();
      this.getCount();
    },
    handleIconClick() {
      this.getList();
      this.getCount();
    },
    toUploadQuery() {
      // console.log(e);
      this.uploadVisible = true;
    },
    handleCurrentChange(val) {
      if (this.gid == val.gid) return;
      // this.currentRow = val;
      // console.log(this.time);
      this.gid = val.gid;
      this.getdetail();
    },
    async getimglist(list, txt) {
      let urllist = "";
      list.forEach((item) => {
        urllist = urllist + "" + item + "|";
      });
      urllist = urllist.substr(0, urllist.length - 1);
      // console.log(urllist);
      try {
        const res = await getServerData(
          APIMAP.INTERVIEW,
          {
            gid: this.gid,
            content: txt,
            imgurl: urllist,
          },
          "put"
        );
        this.activeName = "1";
        this.getList();
        // this.tableData.forEach((item, i) => {
        //   if (item.gid == res.gid) {
        //     this.$set(this.tableData, i, res);
        //   }
        // });
        // this.fmtdetail(res);
        console.log(res);
      } catch (e) {
        console.log(e);
      }
    },
    async getList(e) {
      if (!e) {
        this.listQuery.page = 1;
      }
      try {
        const res = await getServerData(
          APIMAP.INTERVIEW,
          {
            page: this.listQuery.page,
            size: this.listQuery.limit,
            pid: this.userInfo.platformid,
            type: 2,
            status: this.activeName,
            startTime: this.time.length > 0 ? this.time[0] + " 00:00:00" : "",
            endTime: this.time.length > 0 ? this.time[1] + " 23:59:59" : "",
            object: this.input,
          },
          "get"
        );
        console.log("追责列表", res);
        this.tableData = res.rows;
        this.total = res.total;
        if (res.rows.length) {
          this.gid = res.rows[0].gid;
          this.getdetail();
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getdetail() {
      try {
        const res = await getServerData(
          APIMAP.INTERVIEW + "/" + this.gid,
          {
            gid: this.gid,
          },
          "get"
        );
        console.log("追责详情", res);
        this.fmtdetail(res);
      } catch (e) {
        console.log(e);
      }
    },
    fmtdetail(data) {
      var qlist = data.reasondetail.split(";");
      this.detail = data;
      this.questionList = qlist;
      if (data.status == 1) {
        this.imglist = data.imgurl.split("|");
        console.log(this.imglist);
      }
    },
    async getCount() {
      try {
        let params = {};
        params.pid = this.userInfo.platformid;
        params.type = 3;
        if (this.time.length > 0) {
          params = {
            ...params,
            startTime: this.time[0] + " 00:00:00",
            endTime: this.time[1] + " 23:59:59",
          };
        }
        if (this.input !== "") {
          params = {
            ...params,
            object: this.input,
          };
        }
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.COUNT, params);
        console.log("响应数据", res);
        const count = [];
        res.forEach((item) => {
          if (item.type === "待追责") {
            count.push(item.num);
          } else if (item.type === "已追责") {
            count.push(item.num);
          }
        });
        this.count = count;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.contentWrap {
  position: relative;
}
.input {
  width: 300px;
  position: absolute;
  right: 0;
  top: -10px;
}

.upload {
  position: absolute;
  right: 0;
  top: 55px;
}
.upload svg {
  vertical-align: middle;
  margin: -3px 5px 0 0;
}
.icon {
  width: 16px;
  height: 16px;
}

.table {
  margin-top: 20px;
  color: #353e56;
}

.status {
  color: var(--themeColor);
  border: 1px solid var(--themeColor);
  width: 78px;
  height: 32px;
  border-radius: 5px;
  text-align: center;
  line-height: 32px;
}
.demo-image__preview {
  width: 160px;
  .el-image {
    margin: 0 4px;
  }
}
.detail {
  min-height: 675px;
  height: 700px;
  overflow: scroll;
  border-bottom: 1px solid #e2e5ec;
}
.detailItem {
  font-size: 15px;
  margin-top: 24px;
  display: flex;
  color: #707b86;
  .detailContent {
    color: #3b445a;
  }
}

.detailDetail {
  box-sizing: border-box;
  padding: 16px;
  background: #f5f5f5;
  margin-top: 16px;
  border-radius: 2px;
}

.detailDetailWrap {
  font-size: 14px;
  color: #99a9ba;
  display: flex;
  width: 100%;
  &:not(:first-child) {
    margin-top: 14px;
  }
  .detailDate {
    position: relative;
    padding-left: 12px;
    margin-right: 6px;
    &::before {
      content: "";
      position: absolute;
      top: 7px;
      left: -6px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: RGBA(255, 197, 95, 1);
    }
  }
}

.responsibilityBtn {
  display: flex;
  justify-content: flex-end;
  div {
    margin-top: 20px;
    width: 150px;
    height: 42px;
    background: var(--themeColor);
    border-radius: 5px;
    text-align: center;
    line-height: 42px;
    color: white;
    cursor: pointer;
  }
}
</style>